// English language file
export const en_texts = [
	"Hello, ",
	"This is a test!",
	"OK",
	"Cancel",
	"Close",
	"English",
	"မြန်မာ",
	"普通话",
	"Kayin",
	"Rakhine",
	"Chin",
	"တႆး",
	"Jinghpaw",
	"Cannot connect to server. Please check your network connection and try again. If problem persists, please contact our Support.",
	"Home",
	"Explore",
	"Market",
	"Live",
	"Messages",
	"Studio",
	"Me",
	"OK",
	"Error",
	"Delete",
	"(slide left to delete)",
	"SIGNIN WITH GOOGLE",
	"SIGNIN WITH APPLE",
	"SIGIN WITH EMAIL",
	"Email",
	"Password",
	"Forget Password",
	"LOGIN",
	"REGISTER",
	"Are you sure you want to log-out?",
	"Email: ",
	"Edit Your Name",
	"Upload Avatar",
	"Select Language",
	"Logout",
	"Loading...",
	"Upload Content",
	"Choose Your Content",
	"Paste Your Video",
	"Next",
	"Show Me How?",
	"YouTube Video Code:",
	"Video Title:",
	"Description:",
	"Category:",
	"Tags (optional):",
	"Upload",
	"Please add a valid YouTube video code. See Show-me-how on how to find YouTube video code.",
	"Please add a video title before uploading the video.",
	"Close the UI and lose all your data?",
	"Cancel Upload",
	"New Channel",
	"Channel Name:",
	"Description:",
	"Category:",
	"Create Channel",
	"Before you can upload your videos, you must create a channel for them. A user can have many channels to group different types of videos.",
	"Edit Channel",
	"Save",
	"Your Channel:",
	"Channel List:",
	"Your Videos:",
	"Description",
	"Edit Channel",
	"Delete Channel",
	"Are you sure you want to delete this channel and all its video? This cannot be undone.",
	"Upload Channel Image",
	"Edit Channel",
	"Manage All Channels",
	"Invalid YouTube video code. Please check Show-me-how to properly copy the video code.",
	"Channel:",
	"Your content was uploaded successfully!",
	"You do not have any video in this channel.",
	"Add One",
	"Type a message...",
	"Enter Email Address...",
	"Upload Image",
	"Send Money",
	"Load More",
	"Delete Message",
	"Block User",
	"Block List",
	"Delete Chat Message?",
	"Delete all the messages in this chat? It cannot be undone.",
	"Block User?",
	"Are you sure you want to block this user?",
	"network offline...",
	"How Can We Help You?",
	"Let us know your problem and our support team will contact you back as soon as possible!!",
	"Notifications",
	"You have no new notification.",
	"No Blocked User",
	"If you block somebody, they will be shown here.",
	"Block List",
	"Unblock User",
	"Are you sure you want to remove this user from your block list?",
	"You can't send message...",
	"Transaction Date",
	"I Need More Time",
	"Private",
	"Pages",
	"Requested",
	"Search...",
	"No Message",
	"You do not have any message for now.",
	"Create new content...",
	"Create Post",
	"Upload A Video",
	"Add An Image",
	"Create A Post",
	"Visibility:",
	"USD In Your Wallet",
	"Available LIKES (N-Tokens)",  
	"Buy Likes (N-Tokens)",
	"You do not have N-Wallet",
	"Install and set-up N-Wallet app to manage your wallet account better.",
	"Get N-Wallet",
	"Manage Your Money",
	"N-Wallet alllows you to manage all your money and tokens better.",
	"Open N-Wallet",
	"N-Social Games",
	"Check out our cool game selections. You can win Likes by playing our games!!",
	"Play Games",
	"All Apps",
	"Hightlight",
	"New Apps",
	"Games",
	"Direct Download APK",
	"iOS AppStore",
	"Google Playstore",
	"(For Lower Android Version Phones)",
	"Your Wallet",
	"Comments",
	"First Like? Read This First!",
	"LIKES in N-Social is different from other social network. You need to spend one N-Token to like a post. The owner of the post will receive your LIKE as an N-Token where they can spend it on other posts or they can convert it. You will not be able to like a post unless you have N-Tokens inside your account. You can get free N-Token by playing our games or buying it directly inside our wallet.",
	"I Understood",
	"Get Free N-Tokens",
	"What is Super LIKE?",
	"You can like a post as many times as you want. Essentially you are sending N-Tokens to the post owner as an appreciation. Super LIKE allows you to send 10 N-Tokens instead of one showing all others that you are super fan of the post!! You can get free N-Token by playing our games or buying it directly inside our wallet.",
	"You do not have N-Token to send a LIKE. Buy N-Token or play our games to get Free Tokens!!",
	"Be the first to like this...",
	"Write a comment...",
	"Be the first to comment...",
	"Please install N-Wallet and set it up before you can buy or sell N-Tokens.",
	"X-Rate: ",
	"LIKES (N-Tokens):",
	"Buy LIKES",
	"DEL",
	"You do not have enough USD to buy LIKES (N-Tokens).",
	"USD In Your Wallet:",
	"USD Prices:",
	"Exchange Rate:",
	"LIKES (N-Tokens) You Will Receive:",
	"USD Left In Your Wallet:",
	"Buy LIKES",
	"Confirm Purchase",
	"Clear",
	"Confirm",
	"Enter Your Passkey:",
	"Total USD:",
	"LIKES (N-Tokens): ",
	"Back",
	"Purchase Successful",
	"View",
	"LIKE Price",
	"(N-Token To USD Exchange Rate)",
	"updated: ",
	"Buy LIKES",
	"Search...",
	"Message",
	"Follow",
	"Unfollow",
	"Friend",
	"Followed",
	"Share External",
	"Report To Admin",
	"Block User",
	"Followers",
	"Edit Profile",
	"Follow this user",
	"Follow User",
	"Unfollow User",
	"Delete Post",
	"Delete Post?",
	"Are you sure you want to delete this post and lose all comments and likes? This cannot be undone.",
	"Logging Out?",
	"Followers: ",
	"Please write a detail explaination of why this post should not be on N-Social. The more information you include, the better it is for admins to decide what action(s) to be taken. Your report will be ignored if you do not include enough reasons for the report. Thank you for taking the time to keep N-Social community alive and safe!",
	"Reason For Report",
	"Your report has been submitted to our admins. They will check your report and take appropriate action(s).",
	"Notifications",
	"Unread",
	"See All",
	"Supporters:",
	"Invalid Content",
	"Content you are looking for does not exist or it has been deleted.",
	"Forget Your Password?",
	"Enter your email to reset your password:",
	"Reset Password",
	"Create Your Account",
	"Invalid email format",
	"Password must be at least 8 characters",
	"Confirm Password:",
	"Your password and confirmed password do not match",
	"Referral Email:",
	"Register",
	"(We will not share your personal information)",
	"Your Referral ID (Optional)",
	"Confirm Email",
	"A confirmation email has been sent. Please click on the link in the email",
	"Email Confirmed",
	"Resend Email",
	"Email confirmation successful!",
	"Email has been resent. Please check your inbox including the spam folder",
	"Change Name",
	"Enter Your New Name:",
	"Change Name",
	"Change Your Language",
	"Change",
	"English",
	"Mandarin",
	"Myanmar",
	"Post",
	"Add To Post",
	"Picture",
	"Video File",
	"YouTube Video",
	"Article Title",
	"Questionnaire",
	"Hide",
	"Paste YouTube Video",
	"Post Title",
	"What is on your mind...",
	"End of Content...",
	"LIKE To Unlock",
	"SUPER-LIKE To Unlock",
	"LIKE To Unlock This Post",
	"SUPER-LIKE To Unlock This Post",
	"Follow people on N-Social to see their contents here. Go to Explore to check out what other people have posted and if you like their contents you can follow them to see their posts here or give them a like or two too!",
	"Explore Others",
	"Followers / Followed",
	"Photo Gallery",
	"Popular",
	"News & Media",
	"Trending",
	"Latest",
	"18+ NSFW",
	"Currently there is no content in this category. Check back later or explore other categories.",
	"Comment Likes/Dislikes",
	"Copy Text",
	"Delete Comment",
	"Delete Comment?",
	"Are you sure you want to delete this comment? This cannot be undone.",
	"Friends",
	"Followed",
	"Followers",
	"You have no friend yet",
	"Follow other people and when they followed you back, you will become friends. Friends can see each other private posts!",
	"You haven't follow anybody yet",
	"You can follow other people if you like their posts so you can see them everytime they post!",
	"You have no follower",
	"If other people follow you, they will be shown here!",
	"Reply To This",
	"ALL",
	"LIKES",
	"DISLIKES",
	"Replying to...",
	"Share My Profile",
	"New Update Available",
	"Update Information:",
	"Download From PlayStore",
	"Download From AppStore",
	"Direct Download",
	"App is in maintenance mode",
	"We Are Sorry!!",
	"Check Again",
	"NSFW (18+)",
	" reacted ",
	" to this post.",
	"Anonymous",
	"Anonymous Comment",
	"Send Gif",
	"Currently only file size less than ",
	" MB is alllowed. In the future we will allow large files.",
	"Public",
	"Latest From Public Chat",
	"Join Public Chat",
	"Members",
	"[Public] ",
	"Share As Post",
	"Delete Message",
	"Reply To",
	"Close Chat",
	"Open Chat",
	"This chat group is closed by owner",
	"this message was deleted",
	"minimum words: ",
	"Set Background",
	"Clear Background",
	"Share To Public Chat",
	"Post has been shared to your public chat.",
	"Share a post - ",
	"Replies",
	"See All",
	"No Like Available",
	"You do not have enough Likes to react to this post. You can receive Likes if other people react to your posts or buy Likes from our store. ",
	"Or watch Ads and get a free Like. (Note: you will get your Like one hour after watching the ad)",
	"Close",
	"Watch Ads",
	"Or watch Ads and get a free Like. (Note: currently Ad is not available. Check back again later)",
	"Ad Not Available",
	"Change Chat Name",
	"Chat Name",
	"Change Chat Name:",
	"Change",
	"Random Chat",
	"Make new friends within 5 min!!",
	"Exit Random Chat?",
	"Please note that you will have to setup your chat profile again.",
	"Setup Your Profile",
	"Connecting To Random Chat Room",
	"Please wait for server to load...",
	"Connection Error",
	"Cannot connect to the server. Retrying in a few seconds...",
	"Profile Setup",
	"Setup your random chat profile to join other users.",
	"Nickname:",
	"Select Your Profile Avatar:",
	"I Am A:",
	"Want To Chat With:",
	"Boy",
	"Girl",
	"Both",
	"Disconnecting",
	"Disconnecting from random chat server, please wait...",
	"Please Wait",
	"Searching a new user to chat with. Currently ",
	" user(s) online in chat rooms.",
	"Other User Has Left",
	"Other user has left the chat or decided to skip to next chat user. Moving on to next user...",
	"Skip Next",
	"Friend Request",
	"Reveal Identity",
	"Accept Friend Request?",
	"Exit",
	"Enter",
	"Action Buttons",
	"Public Chat Invite",
	"Currently Users Online:  ",
	"Video was deleted or there was an error in upload",
	"No more video currently availabe. Please check back later.",
	"Join This Group Chat",
	"• Sponsored Post",
	"What Is A Sponsored Post?",
	"When you see a sponsored post like this, you can click on it to earn Like tokens. Sponsored companies paid you to see their posts and you can earn Likes by viewing them!",
	"I Understood",
	"Boost Post",
	"Boost A Post",
	"Boost Post",
	"Buy Tokens",
	"Token Amount You Want To Spend:",
	"Estimated User Reach:",
	"Invalid boost token amount.",
	"Cancel Boost",
	"Pause Boost",
	"Unpause Boost",
	"You Boosted With Tokens:",
	"Tokens Already Spent:",
	"Cancel Boost?",
	"Cancel post boost and recover your tokens? Some of the tokens may still be awared to users.",
	"You have received some LIKE tokens from viewing this sponsored post!",
	"Swipe Down To See Previous Video",
	"Swipe Up To See Next Video",
	"Setup New Passkey",
	"Your Passkey is six number code you use when you send money or update your wallet. Only setup with code you can easily remember such as your date of birth.",
	"Send Payment",
	"Amount You Want To Send",
	"Send Money",
	"Your Balance",
	"The amount you tried to send is more than the balance you have.",
	"sent money",
	"Open Wallet",
	"Marketplace",
	"Apps",
	"Wallet",
	"Search marketplace...",
	"Price: ",
	"Location: ",
	"Select Category:",
	"Select a category for your product",
	"Price:",
	"Currency:",
	"Available Location(s):",
	"Add Location",
	"Select Location",
	"You need to select a category for your item before you can post to marketplace",
	"You need to select at least one location for your item before you can post to marketplace",
	"You need to pick at least one image or video for your item before you can post to marketplace",
	"Categories",
	"Sell",
	"Myanmar",
	"Posted By",
	"I am interested in this item. Please tell me more about it.",
	"Send Message To Seller",
	"A message was sent to the seller. Please wait for him/her to response.",
	"Available Location(s)",
	"Select a category:",
	"Search",
	"Cancel",
	"Currently there is no item on Marketplace. Please refine your search.",
	"Make Payment",
	"Make Payment",
	"Close",
	"Payment Successful!",
	"Last Used Apps:",
	"Price: ",
	"Share Post",
	"Share This Post",
	"Close",
	"Exchange",
	"Buy LIKES",
	"Top-Up",
	"Withdraw",
	"N-Token Amount To Exchange",
	"Exchange USD",
	"USD Amount:",
	"Exchange",
	"LIKES (N-Tokens) To Exchange:",
	"Exchange Rate:",
	"USD Amount To Be Received:",
	"LIKES (N-Tokens) Left:",
	"Confirm Exchange",
	"Exchange Success",
	"Crypto Address",
	"Address has been copied!",
	"You can use the following crypto address to transfer from your other coin-wallets like Binance.",
	"Show Me How",
	"Time Left: ",
	"Copy Address",
	"Each address is only valid for ",
	" seconds total. Send your coins before the address is expired.",
	"Invalid address",
	"Invalid amount",
	"WITHDRAW",
	"Enter BEP Address and USDT amount to Withdraw:",
	"BEP-20 Address",
	"USD",
	"Withdraw",
	"Show Me How",
	"Quick Withdraw",
	"Your BEP-20 Address",
	"Edit Default Address",
	"How much do you want to withdraw",
	"Withdraw",
	"Last Withdraw Address(es):",
	"Your withdraw request has been submitted",
	"Withdraw Success",
	"Requested Address:",
	"Amount:",
	"Back",
	"It will take up to 1 hour to receive money at your other wallet.",
	"Withdraw Address",
	"Confirm Withdraw",
	"Sending To:",
	"Amount:",
	"Transfer Fee:",
	"Amount Left in Your Account:",
	"Confirm",
	"Set Up Your Wallet Passkey",
	"You need to setup your wallet's passkey before you can use the wallet functions.",
	"Set-Up Your Passkey",
	"Edit Post",
	"Add your post title here",
	"Edit your post here",
	"Save",
	"Edit Post",
	"Report Copyright Issue",
	"Please provide URL to your copyright content that you own.",
	"Your content URL:",
	"Please explain how and why the post violates your copyright and if your claim is correct, our admin team will take down the post immediately!",
	"View Report(s)",
	"Buy Likes",
	"You can buy Likes with our wallet:",
	"See Apps/Games",
	"(Or) Sometime you get free Likes using our apps/games:",
	"Boost Reports",
	"There is no boost report for this post.",
	"You are already logged in.",
	"You are not logged in. Please log into your account to make purchase.",
	"shares..."
];
